import * as React from 'react'
import { ArticleConfigurationService } from './articleConfigurationService'

export const ArticleConfigurationServiceContext = React.createContext(null as any as ArticleConfigurationService)
